import { camelCase } from 'lodash-es';
import parse from 'style-to-object';

/**
 * Converts a CSS string to a React CSSProperties object or returns the passed object if it's already a CSSProperties object
 *
 * @param {string | React.CSSProperties} css - CSS string to parse or React CSSProperties object to pass through
 * @returns {React.CSSProperties} Parsed CSS as a React style object
 * @example
 * // Returns { fontSize: '16px', color: 'red' }
 * parseCss('font-size: 16px; color: red;')
 */
export function parseCss(css: string | React.CSSProperties): React.CSSProperties {
  if (typeof css !== 'string') {
    return css;
  }

  const output: React.CSSProperties = {};

  try {
    parse(css, (name, value) => {
      // Check for CSS variables and don't camelCase them
      output[name.startsWith('--') ? name : camelCase(name)] = value;
    });
  } catch (error) {
    // Log parse errors (like invalid CSS) and return an empty object
    console.error('Error parsing CSS string', error);
  }

  return output;
}
